import SurvivorPopup from './SurvivorPopup';

export default SurvivorPopup;